<i18n src='@/locale/nurse-localization.json'></i18n>

<template>
    <v-wm-form-dialog
        max-width="90vw"
        :formTitle="item.patientName + ' - ' + item.medicamentName"
        :disableSave='selectedSpecMed.length == 0'
        @save="SaveSpecMed"
        @cancel="$emit('cancel')"
    >
        <v-data-table
            :headers="headers"
            :items="item.specificMeds"
            item-key="id"
            :show-select="showSelect"
            :single-select="singleSelect"
            v-model="selectedSpecMed"
            @click:row="ToggleRow"
            class="available-meds"
        ></v-data-table>
    </v-wm-form-dialog>
</template>

<script>
import VWmFormDialog from '@/component/form-dialog.vue';
import nurseService from '@/service/nurse-service';

export default {
    components: {
        VWmFormDialog,
    },

    props: {
        item: {
            type: Object,
            required: true,
        },
        showSelect: {
            type: Boolean,
            default: false,
        },
        singleSelect: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t('Med_Code'),
                    value: 'code',
                    sortable: false,
                },
                {
                    text: this.$t('Med_Name'),
                    value: 'name',
                    sortable: false,
                },
                {
                    text: this.$t('Med_Quantity'),
                    value: 'quantity',
                    sortable: false,
                },
                {
                    text: this.$t('Med_Unit'),
                    value: 'unit',
                    sortable: false,
                },
                {
                    text: this.$t('Med_Price'),
                    value: 'price',
                    sortable: false,
                },
                {
                    text: this.$t('Med_Exp_Date'),
                    value: 'expDate',
                    sortable: false,
                },
            ],

            selectedSpecMed: [],
        };
    },

    methods: {
        ToggleRow(item) {
            if (this.selectedSpecMed.length == 0) {
                this.selectedSpecMed.push(item);
            } else if (this.selectedSpecMed[0] != item) {
                this.selectedSpecMed = [item]
            } else {
                this.selectedSpecMed = []
            }
        },
        SaveSpecMed() {
            if (this.item.id == null) {
                nurseService.addMkurnal(
                    this.item.prescriptionId,
                    this.item.date,
                    this.item.time,
                    this.selectedSpecMed[0].id,
                    this.item.diagnosisNumber
                ).then(() => {
                    this.$emit('save');
                });
            } else {
                let params = {
                    preDrugTreatmentId: this.item.id,
                    brunvaId: this.selectedSpecMed[0].id,
                };
                nurseService.saveSpecMed(params).then(() => {
                    this.$emit('save');
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.available-meds {
    ::v-deep {
        tbody tr {
            cursor: pointer;
        }
        .v-data-table__selected {
            background-color: #cfd8dc !important;
        }
    }
}
</style>